exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".annex .img-list[data-v-3dd0e383]{padding-top:10px}.annex .img-list .img-wrap[data-v-3dd0e383]{display:block;max-width:100%;margin:0 auto 10px}.annex .img-list .image-slot[data-v-3dd0e383]{width:100%;height:300px;position:relative;background:#eee}.annex .img-list .image-slot .el-icon-loading[data-v-3dd0e383]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
